import React, { Component } from 'react';
import IceBucket from '../../img/ice-Bucket.svg'
import "./style.scss"

export class Graphics extends Component {

  buildImage = () => {
    return (
      <div aria-label="Ice bucket" className="graphics" style={{ pointerEvents: "none" }}>
        <img
          style={{ pointerEvents: "none" }}
          src={IceBucket}
          aria-label={"IceBucket"}
          alt="ice bucket"
        />
      </div>
    );
  };

  render(){
    return(
      <div aria-label="IceBucket" className="graphics">
        {this.buildImage()}
      </div>
    )
  }
}
